'use client';

import { useGetStreamingIndex } from '@/hooks/query/use-streaming-data';
import { useEffect } from 'react';
import { SportMatchModel } from '@nf/types/odds';
import { useStreamingStore } from '@/store/streaming';
import { StreamingBase } from '../streaming-base';

export const DefaultStreaming = ({ match }: { match?: SportMatchModel }) => {
	const [
		streamingSrc,
		channelList,
		streamingUrl,
		setStreamingUrl,
		streamingMatchId,
		isRefresh,
		setIsLoading
	] = useStreamingStore(
		state => [
			state.streamingSrc,
			state.channelList,
			state.streamingUrl,
			state.setStreamingUrl,
			state.streamingMatchId,
			state.isRefresh,
			state.setIsLoading
		]
	);

	const streamingData = channelList?.find((item) => item?.value === streamingSrc);
	const { refetch } = useGetStreamingIndex(match?.MatchId ?? 0, streamingSrc, streamingData?.sid ?? '', match?.TeamId1 ?? 0, match?.TeamId2 ?? 0);

	useEffect(() => {
		if (match?.MatchId !== streamingMatchId || (streamingUrl && !isRefresh)) {
			return;
		}

		refetch().then((res) => {
			const urlData = res.data?.data.Data;
			if (urlData != null) {
				setStreamingUrl(urlData);
			}
			setIsLoading(false);
		});
	}, [channelList, isRefresh, streamingSrc]);

	return <StreamingBase />;
};

